module.exports = __webpack_public_path__ + "static/digitize_your_hand_drawn_wireframes-5cfd44546149ccc868090ee97025fbc9.webp";